module.exports = __webpack_public_path__ + "img/PCT04.9a8566f9.svg";